import { useCallback } from 'react';
import { PaginationStepRoot } from "./styles";
import { PAGINATION_STEP } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
export var PaginationStep = function PaginationStep(_ref) {
  var autoplay = _ref.autoplay,
    hidden = _ref.hidden,
    isActive = _ref.isActive,
    isNext = _ref.isNext,
    isPrevious = _ref.isPrevious,
    pagination = _ref.pagination,
    slideIndex = _ref.slideIndex,
    onPaginationStepClick = _ref.onPaginationStepClick;
  var onClick = useCallback(function () {
    onPaginationStepClick === null || onPaginationStepClick === void 0 || onPaginationStepClick(slideIndex);
  }, [onPaginationStepClick, slideIndex]);
  return /*#__PURE__*/_jsx(PaginationStepRoot, {
    autoplay: autoplay,
    className: isActive ? 'active-pagination-step' : undefined,
    "data-testid": PAGINATION_STEP,
    hidden: hidden,
    isActive: isActive,
    isNext: isNext,
    isPrevious: isPrevious,
    pagination: pagination,
    onClick: onClick
  });
};
//# sourceMappingURL=PaginationStep.js.map